import React from 'react'
import { uuid } from 'lib/utils'
import { onMapboxReady } from 'lib/mapboxUtils'

export class MapboxPolyline extends React.PureComponent {
  state = {
    added: false
  }

  constructor (props) {
    super(props)
    this._id = uuid()
  }

  componentDidMount () {
    const { mapInstance } = this.props
    onMapboxReady(mapInstance, this.addToMap) // I think onMapboxReady might be unreliable
  }

  componentDidUpdate () {
    // we're using an `added` flag instead of onMapboxReady
    // here for performance reasons, but it accomplishes the same thing
    const { mapInstance } = this.props
    const { added } = this.state
    if (!added) { return }
    mapInstance.getSource(this._id).setData(this.geoData())
  }

  componentWillUnmount () {
    const { mapInstance } = this.props
    mapInstance.removeLayer(this._id)
  }

  geoData = () => {
    const { positions } = this.props
    return {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'LineString',
        coordinates: positions.map(point => [point.lng, point.lat])
      }
    }
  }

  addToMap = () => {
    const {
      mapInstance,
      color,
      weight,
      onMouseEnter,
      onMouseLeave,
      onClick
    } = this.props
    const data = this.geoData()
    mapInstance.addLayer({
      id: this._id,
      type: 'line',
      source: {
        type: 'geojson',
        data
      },
      layout: {
        'line-join': 'round',
        'line-cap': 'round'
      },
      paint: {
        'line-color': color,
        'line-width': weight
      }
    })

    onMouseEnter && mapInstance.on('mouseenter', this._id, () => {
      mapInstance.getCanvas().style.cursor = 'pointer'
      onMouseEnter(this._id)
    })
    onMouseLeave && mapInstance.on('mouseleave', this._id, () => {
      mapInstance.getCanvas().style.cursor = ''
      onMouseLeave()
    })
    onClick && mapInstance.on('click', this._id, () => onClick())

    this.setState({ added: true })
  }

  render () {
    return (
      null
    )
  }
}
